<script setup>
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import "element-plus/es/components/button/style/css";
import "element-plus/es/components/notification/style/css";
import Footer from "@/layout/components/Footer.vue";

import AMapLoader from "@amap/amap-jsapi-loader"

import icon_more from "@/assets/home/icon_more.png";
import icon_li from "@/assets/home/icon_li.png";
import icon_noDate from "@/assets/common/ing_noDate.png";

import { getRegionAll, getParkData, getSpatialAll, getMapAll } from "@/api/method/home.js";

import { initStorageValue } from "@/utils";

defineOptions({
  name: "HomePage",
});

const router = useRouter();
const state = initStorageValue();

const homeImg = ref("home_map_bg map_bg_hubei");

// 全国高新区数据
let regionAllData = [];
// 各省高新区数
const regionList = ref([]);
// 空间载体
const imgList = ref([])
let spatialAllData = []

const mapTabItem = ref([{
  id: -1,
  name: "全部",
  value: ["CHENGGUOZHUANHUAPINGTAI", "CHANGYEFUHUAPINGTAI", "CHANYECHUANGXINPINGTAI" , "KEJIFUWUPINGTAI", "CHANYEKONGJIANZAITI"],
  active: true,
  key: 0,
  index: 0
}, {
  id: 1,
  name: "成果转化平台",
  value: ["CHENGGUOZHUANHUAPINGTAI"],
  active: false,
  key: 0,
  index: 0
}, {
  id: 2,
  name: "创业孵化平台",
  value: ["CHANGYEFUHUAPINGTAI"],
  active: false,
  key: 0,
  index: 1
}, {
  id: 3,
  name: "产业创新平台",
  value: ["CHANYECHUANGXINPINGTAI"],
  active: false,
  key: 1,
  index: 0
}, {
  id: 4,
  name: "科技服务平台",
  value: ["KEJIFUWUPINGTAI"],
  active: false,
  key: 1,
  index: 1
}, {
  id: 5,
  name: "产业空间载体",
  value: ["CHANYEKONGJIANZAITI"],
  active: false,
}])

const homeText = ref("中部地区国家高新区G100联盟通过高效整合科技创新资源，精准指引创新方向与产业布局，推动创新链、产业链深度融合，编制了《中部地区科技创新服务平台地图》。地图现汇聚了中部地区22家国家高新区的484个科技创新服务平台，集中展示中部地区范围内的科技成果转化平台、创业孵化平台、产业创新平台、科技服务平台、产业空间载体“四平台一载体”的创新要素，构建开放协同、活力共生的“两创融合”生态体系，推动跨区域资源互通共享，吸引优质科技资源向中部地区集聚和落地，推动中部地区科技创新与产业高质量发展。")

const zonesList = ref({
  id: "",
  name: "",
  describe: "",
  img: "",
  infoArr: []
});

// 高德地图
let geoCodeObj;
let mapObj;
let aMapObj;
let circleMarkArr = [] // 标点对象

const removeMarker = () => {
  if (circleMarkArr.length > 0) {
    for (let i = 0; i < circleMarkArr.length; i++) {
      let marker = circleMarkArr[i];
      mapObj.remove(marker);
    }
  }
}

const setMapMarker = (typeId) => {
  let obj = zonesList.value;
  //设置点坐标
  let coordinate = []
  // if (typeId === 5) { 
  //   for(let i=0; i < spatialAllData.length; i++) {
  //     let element = spatialAllData[i];
  //     if (element.longitude && element.latitude) {
  //       coordinate.push([element.longitude, element.latitude])
  //     }
  //   }
  // } else if (typeId === -1) {
  // } else {
  //   for(let i=0; i < obj.infoArr[key][index].mapList.length; i++) {
  //     let element = obj.infoArr[key][index].mapList[i];
  //     if (element.longitude && element.latitude) {
  //       coordinate.push([element.longitude, element.latitude])
  //     }
  //   }
  // }
  getMapAll({
    platforms: typeId
  }).then((res) => {
    for(let i=0; i < res.length; i++) {
      let element = res[i];
      if (element && element.longitude && element.latitude) {
        coordinate.push([element.longitude, element.latitude])
      }
    }

    //设置圆的半径大小，单位:px
    const radius = 10 
    for(let i=0; i < coordinate.length; i++) {
      let circleMarker = new aMapObj.CircleMarker({
        center:coordinate[i],
        radius: radius, //3D视图下，CircleMarker半径不要超过64px
        strokeColor:'red',
        strokeWeight:1,
        strokeOpacity:0.1,
        fillColor:'rgb(213 212 197)',
        fillOpacity:0.1,
        zIndex:10,
        bubble:true,
        cursor:'pointer',
        clickable: true
      });
      mapObj.add(circleMarker);
      // mapObj.setFitView([circleMarker]);
      circleMarkArr.push(circleMarker);
    }

  })
}

const initMap = (typeId) => {
  AMapLoader.load({
    // 你申请的Key
    key: "043883b1ee09f831084d5859c5cb2079",
    version: "2.0",
    // 需要用到的插件
    plugin: ["AMap.CircleMarker"]
  })
  .then((AMap) => {
    aMapObj = AMap;
    mapObj = new AMap.Map("container", {
      zoom: 5, //初始化地图级别
      center: [ 108, 34],
      viewMode: "2D", //设置地图模式为2D
      resizeEnable: true
    });
    // 清除点
    removeMarker();
    // 标记点
    setMapMarker(typeId);
    mapObj.setZoom(5);
  })
  .catch((err) => {
    console.log(err);
  });
}

const getMapTabItem = (item) => {
  mapTabItem.value.forEach((item) => {
    if (item.active) {
      item.active = false;
    }
  });
  item.active = true;
  initMap(item.value)
}
// 高新区四大平台转化数据
const getMapTabItemData = (type, obj ,res) => {
  switch (type) {
    case "成果转化平台":
      if (obj.infoArr[0][0].list.length < 5) {
        obj.infoArr[0][0].list.push(res)
      }
      obj.infoArr[0][0].mapList.push({
        ...res,
        des: obj.infoArr[0][0].describe
      })
      break;
    case "创业孵化平台":
      if (obj.infoArr[0][1].list.length < 5) {
        obj.infoArr[0][1].list.push(res)
      }
      obj.infoArr[0][1].mapList.push({
        ...res,
        des: obj.infoArr[0][1].describe
      })
      break;
    case "产业创新平台":
      if (obj.infoArr[1][0].list.length < 5) {
        obj.infoArr[1][0].list.push(res)
      }
      obj.infoArr[1][0].mapList.push({
        ...res,
        des: obj.infoArr[1][0].describe
      })
      break;
    case "科技服务平台":
      if (obj.infoArr[1][1].list.length < 5) {
        obj.infoArr[1][1].list.push(res)
      }
      obj.infoArr[1][1].mapList.push({
        ...res,
        des: obj.infoArr[1][1].describe
      })
      break;
  }
}

const getParkDateFun = (id, item) => {
  let obj = {
    id: item.id,
    name: item.name,
    describe: item.introduction || item.describe,
    img: item.zoneImage ? item.zoneImage.url : item.img,
    infoArr: [
      [{
          name: '成果转化平台',
          bgClass: "oneBg",
          describe: `专注于科技成果评估、技术可行性分析等工作，像为早期科技成果 “保驾护航”。通过工程样机生产小批量试制等，提升成果技术成熟度，降
          低市场化风险，促使高校、科研院所成果与市场接轨，快速落地成实际生产力，带动产业技术革新。`,
          list: [],
          mapList: []
        },
        {
          name: '创业孵化平台',
          bgClass: "twoBg",
          describe: `聚焦细分产业领域，为初创企业及团队配备专业服务团队。提供培训、辅导，开展路演活动，助力企业获得投资。同时，对接技术、人才、供应
          链等资源，就像给创业幼苗营造适宜生长的“温室”，助理其茁壮成长，培育新的经济增长力量`,
          list: [],
          mapList: []
        }
      ],
      [
        {
          name: '产业创新平台',
          bgClass: "threeBg",
          describe: `围绕产业技术需求，开展专业化、市场化的服务。进行共性技术研发，提供中试服务，助力企业攻克技术难题，加速创新成果从实验室走向生产
          线。通过应用服务，推动新技术在产业种的广泛应用，提升产业整体竞争力，引领产业向高端化迈进`,
          list: [],
          mapList: []
        },
        {
          name: '科技服务平台',
          bgClass: "foreBg",
          describe: `针对科技企业，提供专业支撑。涵盖研发设备共享、技术咨询、知识产权保护等服务，加速科技成果转化。整合创新链、产业链、资金链和人才
          链，为科技企业营造良好生态，帮助企业突破初始创期困难，培育出一批具有核心竞争力的硬科技公司`,
          list: [],
          mapList: []
        }
      ]
    ]
  }
  getParkData({highTechZoneId: id}).then((res) => {
    for (let index = 0; index < res.length; index++) {
      getMapTabItemData(res[index].serviceType, obj, res[index]);
    }
    zonesList.value = obj;
  });
}

const getRegionList = (item) => {
  regionList.value.forEach((item) => {
    if (item.active) {
      item.active = false;
    }
  });
  item.active = true;
  getParkDateFun(item.id, item)
  getSpatialAllFun(item.id)
}

// 过滤各省高新区数据
const filterRegionData = (name) => {
  let arr = regionAllData.filter(item => item.locationProvince == name);
  let list = [];
  arr.forEach((item, index) => {
    if (index == 0) {
      getParkDateFun(item.id, item)
      getSpatialAllFun(item.id)
    }
    let status = index == 0 ? true : false;
    list.push({
      id: item.id,
      name: item.name,
      active: status,
      describe: item.introduction,
      img: item.zoneImage.url
    });
  })
  regionList.value = list;
}

const mapDivClick = (type) => {
  switch (type) {
    case '湖北省':
      homeImg.value = "home_map_bg map_bg_hubei";
      break;
    case '湖南省':
      homeImg.value = "home_map_bg map_bg_hunan";
      break;
    case '江西省':
      homeImg.value = "home_map_bg map_bg_jiangxi";
      break;
    case '山西省':
      homeImg.value = "home_map_bg map_bg_shanxi";
      break;
    case '河南省':
      homeImg.value = "home_map_bg map_bg_henan";
      break;
  }
  filterRegionData(type)
}

const getRegionAllFun = () => {
  getRegionAll().then((res) => {
    regionAllData = res;
    filterRegionData('湖北省') // 默认展示湖北省数据
  });
}

// 跳转平台列表页面
const clickMore = (data) => {
  state.value.mapList = data
  state.value.breadcrumb = [{ name: "平台列表", path: "/data/list" }];
  router.push({ name: "dataView" })
}

const clickLiMore = (item) => {
  state.value.parkData = item;
  state.value.breadcrumb = [{ name: "详情", path: "/data/space" }];
  router.push({ name: "spaceDetail", query: { id: item.id } })
}

// 空间载体条状
const imgClick = (obj) => {
  state.value.regionData = obj;
  state.value.breadcrumb = [{ name: "园区详情", path: "/data/park" }];
  router.push({ name: "parkDetail", query: { id: obj.id } })
}

const getSpatialAllFun = (id) => {
  let list = [];
  getSpatialAll({ highTechZoneId: id }).then((data) => {
    spatialAllData = data;
    let arr = [];
    for (let k = 0; k < data.length; k++) {
      if( k % 4 == 0 && k != 0){
        list.push(arr)
        arr = []
        arr.push(data[k])
      } else {
        arr.push(data[k])
      }
      if (data.length-1 == k) {
        list.push(arr)
      }
    } 
    imgList.value = list;
  });
}

onMounted(() => {
  getRegionAllFun();
  // 地图数据-默认全部
  getMapTabItem(mapTabItem.value[0]);
});

</script>

<template>
  <el-container class="login-page">
    <el-container>
      <div class="home_div">
        <div class="home_top_div">
          <div class="header_div">
            <span>中部地区科技创新服务平台地图</span>
            <a href="https://zb.hbkcgyl.com" target="_blank">中部科创供应链线上平台</a>
          </div>
          <div class="home_top_box">
            <div class="home_top">
              
            </div>
            <div :class="homeImg">
              <div class="home_text">{{ homeText }}</div>
              <!-- <img :src="homeImg" class="home_img" /> -->
              <div class="hubei_div" @click="mapDivClick('湖北省')"></div>
              <div class="hunan_div" @click="mapDivClick('湖南省')"></div>
              <div class="jiangxi_div" @click="mapDivClick('江西省')"></div>
              <div class="sx_div" @click="mapDivClick('山西省')"></div>
              <div class="henan_div" @click="mapDivClick('河南省')"></div>
              <div class="hubei_map" @click="mapDivClick('湖北省')"></div>
              <div class="hunan_map" @click="mapDivClick('湖南省')"></div>
              <div class="jiangxi_map" @click="mapDivClick('江西省')"></div>
              <div class="sx_map" @click="mapDivClick('山西省')"></div>
              <div class="henan_map" @click="mapDivClick('河南省')"></div>
            </div>
          </div>
        </div>
        
        <div class="home_info">
          <div class="home_content">
            <div class="home_list">
              <div class="list_tab">
                <div class="list_tab_item" 
                  v-for="(item, index) in regionList" 
                  :key="index" 
                  :class="{active: item.active}"
                  @click="getRegionList(item)"
                >
                  <span>{{ item.name }}</span>
                </div>
              </div>
            </div>
            <div class="info_list">
              <div class="item_info">
                <el-row :gutter="60">
                  <el-col :span="12">
                    <div class="item_des">
                      <div class="des_title">
                        <span class="des_text">{{ zonesList.name }}</span>
                        <!-- <img class="des_title_line" src="" /> -->
                      </div>
                      <div class="des_content">{{ zonesList.describe }}</div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <img class="img_des" :src="zonesList.img"  />
                  </el-col>
                </el-row>
              </div>

              <div class="list_region" v-for="(item, index) in zonesList.infoArr" :key="index">
                <div v-for="(obj, key) in item" :key="key" :class="obj.bgClass ? 'item_des item_list ' + obj.bgClass : 'item_des item_list'">
                  <div class="list_info">
                    <span class="info_text">{{obj.name }}</span>
                    <span class="info_des">{{ obj.describe }}</span>
                  </div>
                  <div class="list_li" v-if="obj.mapList.length > 0">
                    <div class="list_li_item" v-for="(arr, n) in obj.list" :key="n" @click="clickLiMore(arr)">
                      <img class="li_img" :src="icon_li" />
                      <span class="li_text">{{ arr.name }}</span>
                    </div>
                  </div>
                  <div class="list_li" v-if="obj.mapList.length == 0">
                    <div class="list_li_item">
                      <img class="li_img" :src="icon_li" />
                      <span class="li_text">暂无数据</span>
                    </div>
                  </div>
                  <div class="more_div" v-if="obj.mapList.length >=5" @click="clickMore(obj.mapList)"><span>查看更多</span><img :src="icon_more" /></div>
                </div>
              </div>
            </div>
            <div class="item_title" v-if="imgList.length > 0 ">中部地区科技创新空间载体</div>
            <div class="item_list_img" v-if="imgList.length > 0">
              <el-carousel indicator-position="outside" :autoplay="false">
                <el-carousel-item v-for="item in imgList" :key="item">
                  <div class="scroll_box"> 
                    <div class="scroll_item" v-for="(obj, index) in item" :key="index">
                      <img class="scroll_img" :src="obj.image ? obj.image.url : icon_noDate" @click="imgClick(obj)" />
                      <div class="scroll_text">{{ obj.name }}</div>
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="item_title">中部地区科技创新服务热力地图</div>
            <div class="home_map">
              <div class="map_tab">
                <div class="map_tab_item" 
                  v-for="(item, index) in mapTabItem" 
                  :key="index" 
                  :class="{active: item.active}"
                  @click="getMapTabItem(item)"
                >
                  <span class="tab_item_text">{{ item.name }}</span>
                </div>
              </div>
              <div id="container" class="map_box"></div>
            </div>
          </div>
        </div>
      </div>
    </el-container>
    <el-footer><Footer></Footer></el-footer>
  </el-container>
</template>

<style scoped lang="scss">
.login-page {
  .el-header {
    min-width:1200px;
    padding: 0px;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .el-footer {
    min-width:1200px;
    height: 155px;
    display: flex;
    background: #031F4A;
    padding: 0px;
  }
  .el-container {
    margin: 0 auto;
    width: 100%;
    min-width:1200px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .home_div {
      display: flex;
      width: 100%;
      min-width: 1200px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .home_top_div{
        width: 100%;
        height: 1410px;
        background: #031F4A;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .header_div{
          width: 100%;
          height: 180px;
          background: url("@/assets/home/icon_home_top.png") no-repeat;
          display:flex;
          flex-direction: column;
          align-items: center;
          background-size: 100% 125%;
          span{
            margin-top: 25px;
            font-family: Source Han Sans SC;
            font-weight: bold;
            font-size: 45px;
            color: #2C7CF4;
            background: linear-gradient(180deg, #CCDFFF 1.3916015625%, #18ACF8 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          a{
            height: 36px;
            margin-top: 10px;
            font-family: Source Han Sans SC;
            font-weight: bold;
            font-size: 36px;
            color: #00A8FC;
            background: linear-gradient(180deg, #CCDFFF 1.3916015625%, #18ACF8 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            display: flex;
            justify-content: center;
            align-items: anchor-center;
          }
        }
        .home_top_box{
          margin-top: 50px;
          width: 1200px;
          height:100%;
          background: url("@/assets/home/icon_home_bottom.png") -368px -381px no-repeat;
          display: flex;
          flex-direction: column;
          align-items: center;
          .home_map_bg{
            width: 1200px;
            height: 1130px;
            position: relative;
            .home_text{
              position: absolute;
              top: 20px;
              text-indent: 33px;
              width: 414px;
              font-family: Source Han Sans SC;
              font-weight: 400;
              font-size: 17px;
              color: #00a8fc;
              line-height: 18px;
            }
            .hubei_div{
              width: 281px;
              height: 204px;
              position: absolute;
              top: 551px;
              right: 28px;
              cursor: pointer;
            }
            .hubei_map{
              cursor: pointer;
              width: 351px;
              height: 155px;
              position: absolute;
              top: 632px;
              right: 476px;
            }
            .hunan_div{
              width: 281px;
              height: 182px;
              position: absolute;
              top: 552px;
              left: 7px;
              cursor: pointer;
            }
            .hunan_map{
                cursor: pointer;
                width: 248px;
                height: 293px;
                position: absolute;
                top: 793px;
                right: 599px;
            }
            .jiangxi_div{
              width: 281px;
              height: 182px;
              position: absolute;
              top: 924px;
              right: 12px;
              cursor: pointer;
            }
            .jiangxi_map{
              cursor: pointer;
              width: 248px;
              height: 293px;
              position: absolute;
              top: 795px;
              right: 333px;
            }
            .sx_div{
              width: 281px;
              height: 86px;
              position: absolute;
              top: 322px;
              left: 77px;
              cursor: pointer;
            }
            .sx_map{
              cursor: pointer;
              width: 212px;
              height: 355px;
              position: absolute;
              top: 38px;
              left: 456px;
            }
            .henan_div{
              width: 281px;
              height: 182px;
              position: absolute;
              top: 194px;
              right: -8px;
              cursor: pointer;
            }
            .henan_map{
              cursor: pointer;
              width: 281px;
              height: 182px;
              position: absolute;
              top: 413px;
              right: 438px;
            }
          }
          .map_bg_hubei{
            background: url("@/assets/home/icon_hb.png") 0px -10px no-repeat;
          }
          .map_bg_henan{
            background: url("@/assets/home/icon_henan.png") 0px -10px no-repeat;
          }
          .map_bg_hunan{
            background: url("@/assets/home/icon_hn.png") 0px -10px no-repeat;
          }
          .map_bg_jiangxi{
            background: url("@/assets/home/icon_jx.png") 0px -10px no-repeat;
          }
          .map_bg_shanxi{
            background: url("@/assets/home/icon_sx.png") 0px -10px no-repeat;
          }
        }
      }
      .home_info{
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, #F2F4FE 0%, #FFFFFF 55.00000000000001%, #F2F4FE 100%);
      }
      .home_content{
        width: 1200px;
        display: flex;
        flex-direction: column;
        margin: 0 auto;
        margin-top:25px;
        .home_list{
          padding: 0px 0px;
          display: flex;
          flex-direction: column;
          .list_tab{
            padding: 0px 10px;
            min-height: 105px;
            background: #E7EDFD;
            border-radius: 20px;
            display: flex;
            align-items: center;
            .list_tab_item{
              max-width: 197px;
              height: 74px;
              border-radius: 10px;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-right: 15px;
              cursor: pointer;
              span{
                max-width: 130px;
                padding: 10px;
                height: 42px;
                font-family: Source Han Sans SC;
                font-weight: 400;
                font-size: 18px;
                color: #020A1A;
                line-height: 24px;
                text-align: center;
                display: flex;
                justify-content: center;
                align-items: center;
              }
            }
            .active{
              background: #0261FF;
              span{
                max-width: 130px;
                padding: 10px;
                height: 42px;
                text-align: center;
                font-family: Source Han Sans SC;
                font-weight: 400;
                font-size: 18px;
                color: white;
                line-height: 24px;
              }
            }
          }
        }
        .info_list {
          width: 100%;
          display: flex;
          flex-direction: column;
          .item_info{
            width: 100%;
            margin-top: 40px;
            .item_des {
              width: calc(100% - 40px);
              display: flex;
              flex-direction: column;
              padding: 0px;
              .des_title{
                width: 100%;
                height: 50px;
                display: flex;
                flex-direction: column;
                span{
                  font-family: Source Han Sans SC;
                  font-weight: bold;
                  font-size: 28px;
                  color: #020A1A;
                }
              }
              .des_content{
                margin-top: 20px;
                font-family: Source Han Sans SC;
                font-weight: 400;
                font-size: 17px;
                color: #020A1A;
                line-height: 24px;
              }
            }
            .img_des {
              width: 100%;
              height: 382px;
            }
          }
          .list_region{
            width: 100%;
            // min-height: 624px;
            display: flex;
            justify-content: space-between;
            margin-top: 20px;
            .item_list{
               width: calc(50% - 5px);
               min-width: 614px;
              .list_info {
                width: 82%;
                height: 30%;
                display: flex;
                flex-direction: column;
                margin: 85px 0px 32px 50px;
                .info_text{
                  font-family: Source Han Sans SC;
                  font-weight: bold;
                  font-size: 30px;
                  color: #020A1A;
                }
                .info_des{
                  margin-top: 30px;
                  font-family: Source Han Sans SC;
                  font-weight: 400;
                  font-size: 17px;
                  color: #495973;
                }
              }
              .list_li{
                height: 35%;
                margin: 0px 0px 0px 50px;
                padding-top: 20px;
                .list_li_item{
                  width: 90%;
                  margin-top: 15px;
                  display: flex;
                  align-items: center;
                  .li_img{
                    width: 15px;
                    height: 15px;
                  }
                  .li_text{
                    margin-left: 10px;
                    font-family: Source Han Sans SC;
                    font-weight: 400;
                    font-size: 17px;
                    color: #020A1A;
                    cursor: pointer;
                  }
                }
              }
              .more_div{
                width: 90%;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                cursor: pointer;
                span{
                  font-family: Source Han Sans SC;
                  font-weight: 400;
                  font-size: 17px;
                  color: #495973;
                }
                img{
                  width: 30px;
                  height: 10px;
                  margin-left: 5px;
                }
              }
            }
            .oneBg{
              height: 624px;
              background: url("@/assets/home/icon_1.png") -15px 0px no-repeat;
            }
            .twoBg{
              height: 624px;
              background: url("@/assets/home/icon_2.png") -5px 0px no-repeat;
            }
            .threeBg{
              height: 624px;
              background: url("@/assets/home/icon_3.png") -15px 0px no-repeat;
            }
            .foreBg{
              height: 624px;
              background: url("@/assets/home/icon_4.png") -5px 0px no-repeat;
            }
          }
        }
        .item_title{
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 120px;
          font-family: Source Han Sans SC;
          font-weight: bold;
          font-size: 36px;
          color: #020A1A;
        }
        .item_list_img{
          min-width: 1210px;
          padding: 0px 0px;
          .scroll_box{
            width: 100%;
            display: flex;
            .scroll_item{
              width: calc( 25% - 10px );
              margin-right: 10px;
              .scroll_img{
                width: 100%;
                min-width: 280px;
                height: 212px;
                cursor: pointer;
              }
              .scroll_text{
                font-family: Source Han Sans SC;
                font-weight: 400;
                font-size: 16px;
                color: #020A1A;
                display: flex;
                justify-content: center;
              }
            }
          }
        }
        .home_map{
          padding: 0px 0px;
          margin-top: 20px;
          .map_tab{
            display: flex;
            justify-content: space-between;
            width: 100%;
            height: 50px;
            .map_tab_item{
              width: 180px;
              height: 50px;
              font-family: Source Han Sans SC;
              font-weight: 400;
              font-size: 18px;
              color: #020A1A;
              background: #E7EDFD;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
            }
            .active{
              background: #0261FF;
              color: #F5F7FE;
            }
          }
          .map_box{
            margin: 20px 0px;
            height: 600px;
          }
        }
      }
    }
  }
}
</style>
<style>
.el-carousel__container{
  height: 250px;
}
</style>
